import { render, staticRenderFns } from "./GrTestParametersList.vue?vue&type=template&id=4f4ba395&scoped=true&"
import script from "./GrTestParametersList.vue?vue&type=script&lang=js&"
export * from "./GrTestParametersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4ba395",
  null
  
)

export default component.exports